module.exports = __webpack_public_path__ + "static/media/sportAvatar__gears.806abe1b.jpg";